import { httpAuth2 } from "@/api/auth";

export const metricsRequests = {
  create_metric: function ({ context, entity_id, entity_type, metadata, pk, rank, segments } = {}) {
    const data = {
      entity_id,
      entity_type,
      pk,
      rank,
    };

    if (segments) {
      data.segments = segments;
    }
    if (metadata) {
      data.metadata = metadata;
    }

    return httpAuth2.post("/v1/metrics/create_metric", { context, json: data }).json();
  },
};
